import React, { useEffect, useState } from "react";
import WeekArticleQuiz from "./ArticleWeekQuiz";
import { fetchQuizByLink } from "../../pages/fetchQuizs";



export default function ArticleQuiz() {
  const [quiz, setQuiz] = useState(null);
  const [responseId, setResponseId] = useState(null);

  const handleHashChange = (e) => {
    const hash = document.location.hash;
    if (hash && hash.startsWith('#quiz-')) {
      if (hash.split('-').length > 2) {
        const _responseId = parseInt(hash.split(('-')).pop());
        if (_responseId > 1) {
          const quizElement = document.querySelector('.ArticleQuiz');
          const yOffset = -200; // adjust the offset as needed
          const y = quizElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });

        }
        //const _responseId = parseInt(hash.substring('#r'.length));
        setResponseId(_responseId);
      }
      const quizElement = document.querySelector('.ArticleQuiz');
      const yOffset = -100; // adjust the offset as needed
      const y = quizElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  useEffect(() => {
    handleHashChange();
    window.addEventListener("hashchange", handleHashChange, false);
    return () => {
      window.removeEventListener("hashchange", handleHashChange, false);
    }
  }, [])



  useEffect(() => {
    async function fetching() {
      const link = window.location.pathname;
      const quiz = await fetchQuizByLink(link);
      setQuiz(quiz);
    }
    fetching();
  }, []);

  return (
    <div className="ArticleQuiz">
      <h2 className="headline quizHeadline">Pop Quiz</h2>
      {quiz != null ? (responseId === null ? <WeekArticleQuiz quiz={quiz} /> : <WeekArticleQuiz quiz={quiz} responseId={responseId} />) : <div>quiz not found</div>}
    </div>
  );
}
